<template>
    <b-button
        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
        :variant="variant"
        :size="size"
        :block="block"
        :disabled="disabled"
        @click="$emit('click')"
    >
        <slot/>
    </b-button>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { BButton } from 'bootstrap-vue'

export default {
    directives: {Ripple},
    components: {BButton},
    props: {
        variant: {
            default: 'primary'
        },
        block: {
            default: false
        },
        size: {
            default: null
        },
        disabled: {
            default: false
        },
    },
}
</script>
